export default __webpack_public_path__ + "static/media/fan-coil-unit.1d5eecc6.png";